import FormIncidencia from "./form";


export default function AgregarIncidencia() {
    return (
        <FormIncidencia/>
    )
}